// Capped BOGO guard: patches fetch so every /cart/add on the site is checked,
// and a capped item already in the cart is blocked with the capped-bogo popup.
(function () {
  'use strict';

  var config = window.CappedBogoConfig;
  if (!config) return;

  var CART_ADD_RE = /\/cart\/add(\.js)?(\?|$)/;
  var STORAGE_KEY = 'cappedBogoKnown';

  var origFetch = window.fetch.bind(window);

  var cappedProductIds = new Set((config.cartProductIds || []).map(Number));
  var cappedVariantIds = new Set((config.cartVariantIds || []).map(Number));
  var checkedHandles = new Set();
  var variantProduct = Object.create(null);

  try {
    var stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
    (stored.p || []).forEach(function (id) { cappedProductIds.add(Number(id)); });
    (stored.v || []).forEach(function (id) { cappedVariantIds.add(Number(id)); });
    (stored.h || []).forEach(function (h) { checkedHandles.add(h); });
  } catch (e) { /* storage disabled — seed only */ }

  function persist() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        p: Array.from(cappedProductIds),
        v: Array.from(cappedVariantIds),
        h: Array.from(checkedHandles),
      }));
    } catch (e) { /* ignore */ }
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function toId(raw) {
    if (raw == null) return 0;
    var str = String(raw).trim();
    if (str.indexOf('/') !== -1) str = str.split('/').pop();
    var n = Number(str);
    return Number.isFinite(n) ? n : 0;
  }

  // ─── Popup (shared .popup-overlay, .is-open toggle) ───
  var POPUP_SELECTOR = '.popup-for-capped-bogo';
  var popupWired = false;

  function wirePopup() {
    if (popupWired) return;
    popupWired = true;
    document.addEventListener('click', function (event) {
      var popup = event.target.closest(POPUP_SELECTOR);
      if (!popup) return;
      // backdrop, close (×) or OK button
      if (event.target === popup || event.target.closest('.popup-close, .popup-button')) {
        hidePopup();
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var el = document.querySelector(POPUP_SELECTOR);
      if (el && el.classList.contains('is-open')) hidePopup();
    });
  }

  // messageOverride lets the type-cap check show its own wording in the same popup.
  function showPopup(messageOverride) {
    wirePopup();
    var el = document.querySelector(POPUP_SELECTOR);
    if (!el) return;
    var text = messageOverride || config.message;
    if (text) {
      var msg = el.querySelector('.popup-content');
      if (msg) msg.textContent = text;
    }
    el.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
  }

  function hidePopup() {
    var el = document.querySelector(POPUP_SELECTOR);
    if (el) el.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
  }

  // ─── Variant ids from a /cart/add request body ───
  function extractVariantIds(body) {
    var ids = [];
    try {
      if (body instanceof FormData) {
        if (body.has('id')) ids.push(toId(body.get('id')));
        body.forEach(function (val, key) {
          if (/^items\[\d+\]\[id\]$/.test(key)) ids.push(toId(val));
        });
      } else if (body instanceof URLSearchParams) {
        if (body.has('id')) ids.push(toId(body.get('id')));
      } else if (typeof body === 'string' && body) {
        var parsed = null;
        try { parsed = JSON.parse(body); } catch (e) { parsed = null; }
        if (parsed && typeof parsed === 'object') {
          if (parsed.id) ids.push(toId(parsed.id));
          if (Array.isArray(parsed.items)) {
            parsed.items.forEach(function (it) { if (it && it.id) ids.push(toId(it.id)); });
          }
        } else {
          var sp = new URLSearchParams(body);
          if (sp.has('id')) ids.push(toId(sp.get('id')));
        }
      }
    } catch (e) { /* unknown body — fail open */ }
    return ids.filter(function (n) { return n > 0; });
  }

  // Returns the variant ids that must NOT be added (capped and already in cart).
  function findBlocked(variantIds) {
    if (!variantIds.length) return Promise.resolve([]);
    if (!cappedProductIds.size && !cappedVariantIds.size) return Promise.resolve([]);

    return origFetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return [];

        cart.items.forEach(function (i) {
          if (i && i.variant_id && i.product_id) variantProduct[Number(i.variant_id)] = Number(i.product_id);
        });

        return variantIds.filter(function (vid) {
          if (cappedVariantIds.has(vid) &&
              cart.items.some(function (i) { return i.variant_id === vid && i.quantity >= 1; })) {
            return true;
          }
          var pid = variantProduct[vid];
          if (pid && cappedProductIds.has(pid) &&
              cart.items.some(function (i) { return i.product_id === pid && i.quantity >= 1; })) {
            return true;
          }
          return false;
        });
      })
      .catch(function () { return []; });
  }

  // Drops blocked ids from a multi-item JSON body so allowed lines still add;
  // returns null when nothing can be salvaged.
  function bodyWithoutBlocked(body, blocked, init) {
    if (typeof body !== 'string' || !body) return null;
    var parsed;
    try { parsed = JSON.parse(body); } catch (e) { return null; }
    if (!parsed || !Array.isArray(parsed.items)) return null;

    var blockedSet = new Set(blocked);
    var kept = parsed.items.filter(function (it) { return it && !blockedSet.has(toId(it.id)); });
    if (!kept.length || kept.length === parsed.items.length) return null;

    parsed.items = kept;
    var nextInit = Object.assign({}, init);
    nextInit.body = JSON.stringify(parsed);
    return nextInit;
  }

  // Per-product-type qty cap (config.cappedTypes): add first, then trim the cart
  // back to the cap — avoids a cart.js round-trip before every add.
  function enforceTypeCap(justAddedVariantIds) {
    var cappedTypes = config.cappedTypes || {};
    if (!Object.keys(cappedTypes).length) return Promise.resolve();

    return origFetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return;

        var byType = {};
        cart.items.forEach(function (item) {
          var t = String(item.product_type || '').trim().toLowerCase();
          if (!Object.prototype.hasOwnProperty.call(cappedTypes, t)) return;
          (byType[t] = byType[t] || []).push(item);
        });

        var corrections = [];
        var overCapTypes = [];

        Object.keys(byType).forEach(function (t) {
          var maxQty = Number(cappedTypes[t]) || 4;
          var lines = byType[t];
          var total = lines.reduce(function (s, l) { return s + l.quantity; }, 0);
          if (total <= maxQty) return;

          overCapTypes.push({ type: t, maxQty: maxQty });
          var overage = total - maxQty;

          // Trim the just-added lines first; fall back to the last line of that type.
          var justAddedLines = lines.filter(function (l) {
            return justAddedVariantIds.indexOf(l.variant_id) !== -1;
          });
          var trimTargets = justAddedLines.length ? justAddedLines : lines.slice(-1);

          trimTargets.forEach(function (line) {
            if (overage <= 0) return;
            var reduceBy = Math.min(overage, line.quantity);
            var newQty = line.quantity - reduceBy;
            overage -= reduceBy;
            corrections.push(
              origFetch(root() + 'cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: line.key, quantity: newQty }),
              }).catch(function () { /* fail open */ })
            );
          });
        });

        if (!overCapTypes.length) return;

        // Show popup right away; only the refresh events wait for the correction.
        var first = overCapTypes[0];
        showPopup('You can only add ' + first.maxQty + ' of this product to your cart');

        return Promise.all(corrections).then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
        });
      })
      .catch(function () { /* fail open */ });
  }

  // ─── Learn capped product ids (capped-product-bogo tag) from a successful add ───
  function learnFromAddResponse(response) {
    return response.json().then(function (data) {
      var lines = [];
      if (data && Array.isArray(data.items)) lines = data.items;
      else if (data && data.id) lines = [data];

      var lookups = [];
      lines.forEach(function (ln) {
        if (!ln) return;
        if (ln.variant_id && ln.product_id) variantProduct[Number(ln.variant_id)] = Number(ln.product_id);

        var handle = ln.handle;
        if (!handle || checkedHandles.has(handle)) return;
        if (checkedHandles.size >= 40) return; // per-session safety cap
        checkedHandles.add(handle);

        lookups.push(
          origFetch(root() + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (p) {
              if (p && Array.isArray(p.tags) && p.tags.indexOf('capped-product-bogo') !== -1) {
                cappedProductIds.add(Number(p.id));
              }
            })
            .catch(function () { /* ignore */ })
        );
      });

      return Promise.all(lookups).then(persist);
    }).catch(function () { /* ignore */ });
  }

  // ─── Public API (product-form.js feeds variant-level caps) ───
  window.CappedBogoGuard = {
    showPopup: showPopup,
    markCapped: function (opts) {
      opts = opts || {};
      var productId = Number(opts.productId) || 0;
      var variantId = Number(opts.variantId) || 0;
      if (productId && variantId) variantProduct[variantId] = productId;
      if (opts.tagCap && productId) cappedProductIds.add(productId);
      else if (variantId) cappedVariantIds.add(variantId);
      persist();
    },
  };

  // ─── fetch patch ───
  window.fetch = function (input, init) {
    var url, method, body;
    try {
      url = typeof input === 'string' ? input : (input && input.url) || '';
      method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      body = (init && init.body) != null ? init.body : null;
    } catch (e) {
      return origFetch(input, init);
    }

    if (method !== 'POST' || !CART_ADD_RE.test(url)) {
      return origFetch(input, init);
    }

    var variantIds = extractVariantIds(body);

    // Only the pre-check is wrapped; the real add runs once and is never retried.
    return findBlocked(variantIds)
      .catch(function () { return []; })
      .then(function (blocked) {
        if (!blocked.length) return passThrough(input, init, variantIds);

        showPopup();

        // Salvage allowed lines of a bundle add; otherwise block outright.
        var salvaged = bodyWithoutBlocked(body, blocked, init);
        if (salvaged) return passThrough(input, salvaged, variantIds);

        return new Response(
          JSON.stringify({ status: 422, message: 'Cart Error', description: config.message }),
          { status: 422, headers: { 'Content-Type': 'application/json' } }
        );
      });
  };

  function passThrough(input, init, variantIds) {
    return origFetch(input, init).then(function (response) {
      if (response && response.ok) {
        try { learnFromAddResponse(response.clone()); } catch (e) { /* ignore */ }
        try { enforceTypeCap(variantIds || []); } catch (e) { /* ignore */ }
      }
      return response;
    });
  }
})();
